import React from 'react';

import App from './src/components/App';
// custom typefaces
// import 'typeface-montserrat';
// import 'typeface-merriweather';
// import 'typeface-russo-one';

// import './src/styles/global.css';
// import 'prism-themes/themes/prism-shades-of-purple.css';

export const onClientEntry = () => {
	// console.log('THEME ->', window.localStorage.getItem('theme'));
	// const themeFromStorage = window.localStorage.getItem('theme');
	// const defaultTheme = themeFromStorage || 'light';
	// const body = document.querySelector('body');
	// body.classList.add(defaultTheme);
	// if (process.env.BUILD_STAGE === 'develop') {
	// 	const head = document.head;
	// 	const typographyEl = document.getElementById('typography.js');
	// 	const CSSReset = require('!postcss-loader!./src/styles/global.css');
	// 	const styleNode = document.createElement('style');
	// 	styleNode.id = 'css-reset';
	// 	styleNode.innerHTML = CSSReset;
	// 	if (typographyEl) {
	// 		head.insertBefore(styleNode, typographyEl);
	// 	} else {
	// 		if (head.firstChild) {
	// 			head.insertBefore(styleNode, head.firstChild);
	// 		} else {
	// 			head.appendChild(styleNode);
	// 		}
	// 	}
	// }
};

export const wrapRootElement = ({ element }) => {
	return <App>{element}</App>;
};
